@for (tick of ticks; track tick) {
  <svg:line
    class="grid-hor"
    [attr.x1]="0"
    [attr.x2]="dimensions.boundedWidth"
    [attr.y1]="scale(tick)"
    [attr.y2]="scale(tick)"
    ></svg:line>
  }

